<template>
<!--  -->
  <div class="min-h-screen from-indigo-100 bg-gradient-to-r to-pink-100 dark:from-indigo-900/60 dark:to-pink-900/30">
    <carousel :items-to-show="1" ref="onboardingCarousel" class="w-full mx-auto sm:max-w-2xl sm:pt-8">
      <slide v-for="slide in 4" :key="slide" class="block p-4 py-8 mt-8 sm:mt-16 sm:p-6">
        <div v-if="slide === 1">
          <div v-if="userData">
            <h1 class="text-2xl font-semibold text-center text-gray-900 dark:text-white sm:mt-0 sm:pt-0 sm:text-4xl">
              Welcome onboard<span class="ml-1" v-if="userData.firstName">{{ userData.firstName }}</span
              >!
            </h1>
            <!-- Graphic -->
            <div class="flex items-center justify-center py-10 space-x-3 text-left sm:space-x-5">
              <div class="flex-shrink-0">
                <UserProfilePhoto class="flex-shrink-0 w-12 h-12 sm:h-14 sm:w-14" :photo="userData.profileImgUrl" :firstName="userData.firstName" :lastName="userData.lastName" />
              </div>
              <div>
                <PlusIcon class="w-5 h-5 text-gray-500 dark:text-gray-400" />
              </div>
              <div>
                <IconBlackSvg class="inline-flex items-center justify-center object-cover w-12 h-12 rounded-full sm:h-14 sm:w-14" alt="user-profile-picture" />
              </div>
              <div>
                <MenuAlt4Icon class="w-5 h-5 text-gray-500 dark:text-gray-400" />
              </div>
              <div>
                <span class="text-5xl animate-pulse sm:text-6xl">
                  🧠
                  <!-- <v-icon name="fa-brain" scale="3" class="text-yellow-500 animate__flash animate__animated animate__repeat-3 3" /> -->
                </span>
              </div>
            </div>

            <!-- Text -->
            <div class="px-4 space-y-5 sm:space-x-10 sm:px-6">
              <div class="block space-y-5">
                <p class="text-gray-900 dark:text-white">Our goal is to make you smarter. How?</p>
                <p class="text-gray-900 dark:text-white">Wisery empowers you to retain, recall and use information effectively and long-term.</p>
                <div>
                  <a @click="nextSlide" class="underline dark:text-white">It works in 2 simple steps</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="slide === 2">
          <h1 class="text-2xl font-semibold text-center text-gray-900 dark:text-white sm:mt-0 sm:pt-0 sm:text-4xl">Save all your favorite content</h1>
          <div class="my-8 space-y-8">
            <!-- Image -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-full h-full mx-auto sm:w-1/2"
              data-name="Layer 1"
              width="884.54918"
              height="560"
              viewBox="0 0 884.54918 560"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <rect id="e95f2213-9bcc-4eb0-8355-05af38a3eafb" data-name="Rectangle 246" x="0.24277" y="0.32251" width="397.42609" height="208.67749" fill="#f2f2f2" />
              <rect id="b36aff44-79c8-4945-b2be-fafe94103ec8" data-name="Rectangle 264" width="397.42609" height="24.19149" fill="#e6e6e6" />
              <rect id="e8d246b5-3278-4a22-b53c-870d78135d7d" data-name="Rectangle 247" x="9.23028" y="34" width="381" height="164" fill="#fff" />
              <circle id="af47f094-7758-4c77-9c4d-96df8007094d" data-name="Ellipse 194" cx="37.66058" cy="12.03393" r="4.00175" fill="#fff" />
              <circle id="a9e4940e-a814-4d65-8cf9-dbeaebbe294d" data-name="Ellipse 195" cx="52.85057" cy="12.03393" r="4.00175" fill="#fff" />
              <circle id="a19a9b15-8247-4a07-9472-be354b993276" data-name="Ellipse 246" cx="22.43115" cy="12.03393" r="4.00175" fill="#fff" />
              <g id="e40d22fe-578f-4c94-aa61-62d9a8853a42" data-name="Group 31">
                <rect id="fc650e0a-90d3-4f46-9c22-349406f6a431" data-name="Rectangle 250" x="94.66582" y="82.05956" width="219.08741" height="9.76443" fill="#f2f2f2" />
                <rect id="a9c22b9d-d16d-4876-9a73-2e204591d63b" data-name="Rectangle 251" x="94.66582" y="106.47031" width="78.11479" height="9.76443" fill="#f2f2f2" />
                <rect id="a9cac377-a398-4b66-a887-af8e1ff2458e" data-name="Rectangle 252" x="94.66582" y="130.88106" width="155.61961" height="9.76443" fill="#f2f2f2" />
              </g>
              <rect id="ae236caa-6983-426a-9b06-907acb2b0100" data-name="Rectangle 246" x="90.22846" y="273.62195" width="374.00182" height="196.37805" fill="#f2f2f2" />
              <rect id="a3b9e66a-d826-4708-839f-4ee527686343" data-name="Rectangle 264" x="90" y="273.31845" width="374.00182" height="22.76564" fill="#e6e6e6" />
              <rect id="aab7f417-816b-4c9c-990d-381bde365131" data-name="Rectangle 247" x="98.11455" y="304" width="359.11573" height="156" fill="#fff" />
              <circle id="f8f639d0-e29b-4d5a-b588-284205311750" data-name="Ellipse 194" cx="125.44086" cy="284.6431" r="3.76589" fill="#fff" />
              <circle id="b51d82ba-e700-447e-8693-718cbf9a6186" data-name="Ellipse 195" cx="139.73556" cy="284.6431" r="3.76589" fill="#fff" />
              <circle id="adf412b1-46d6-41c6-a8e7-cb0dafcb21cb" data-name="Ellipse 246" cx="111.10906" cy="284.6431" r="3.76589" fill="#fff" />
              <rect id="bb724a05-1311-47ea-a197-dba61202444a" data-name="Rectangle 246" x="270.271" y="86.06159" width="443.63098" height="232.93841" fill="#e6e6e6" />
              <rect id="b7251c64-c1f0-4c9d-92b0-874b7a83a8e9" data-name="Rectangle 264" x="270" y="85.70159" width="443.63098" height="27.004" fill="#f50057" />
              <rect id="ab817a57-2f27-4757-8aa6-60cd0ec7b964" data-name="Rectangle 247" x="280.23028" y="121" width="423" height="185" fill="#fff" />
              <circle id="a7798ced-ee1a-4794-8024-1e89386a0136" data-name="Ellipse 194" cx="312.03901" cy="99.13459" r="4.467" fill="#fff" />
              <circle id="a86efddc-376d-49bc-bb2f-084d39c183b3" data-name="Ellipse 195" cx="328.995" cy="99.13459" r="4.467" fill="#fff" />
              <circle id="be9ec433-53e3-4401-a112-00f5748904d3" data-name="Ellipse 246" cx="295.03901" cy="99.13459" r="4.467" fill="#fff" />
              <g id="e9ebe1f0-a35b-432b-8b90-74480dfb3bf9" data-name="Group 31">
                <rect id="f96caaa1-6c15-4961-b53f-9d0c3661d201" data-name="Rectangle 250" x="329.78549" y="168.6355" width="324.33099" height="14.455" fill="#e6e6e6" />
                <rect id="b84ba293-ba99-4f02-8939-e0d4d3784a38" data-name="Rectangle 251" x="329.78549" y="204.7725" width="115.639" height="14.455" fill="#e6e6e6" />
                <rect id="b3127a43-0306-472e-b694-e809c29e74cb" data-name="Rectangle 252" x="329.78549" y="240.9095" width="230.375" height="14.455" fill="#e6e6e6" />
              </g>
              <g id="b98a0618-17e9-4407-b210-398d3f3d6a2f" data-name="Group 31">
                <rect id="f815513a-42d1-48f0-8051-0e3f5098eb8b" data-name="Rectangle 250" x="163.6717" y="350.30143" width="244.55858" height="10.89965" fill="#f2f2f2" />
                <rect id="fd32ddd7-816d-43c9-8317-e96306581af5" data-name="Rectangle 251" x="163.6717" y="377.55017" width="87.19645" height="10.89965" fill="#f2f2f2" />
                <rect id="eae90b12-7883-428a-9e47-6f1258f1f191" data-name="Rectangle 252" x="163.6717" y="404.79892" width="173.71199" height="10.89965" fill="#f2f2f2" />
              </g>
              <polygon points="502.342 89.215 481.491 100.766 503.728 92.924 502.342 89.215" fill="#fff" />
              <ellipse cx="665.84471" cy="259.43493" rx="5.81718" ry="11.71979" transform="translate(-205.30234 48.38338) rotate(-17.99425)" fill="#3f3d56" />
              <polygon points="509.46 82.667 523.29 77.675 526.23 85.817 512.845 94.858 509.46 82.667" fill="#3f3d56" />
              <path
                d="M677.57211,256.66414a13.47016,13.47016,0,0,0,18.88348,8.36887l34.02,33.67523L735.352,274.316l-33.05362-28.239a13.54316,13.54316,0,0,0-24.72631,10.58715Z"
                transform="translate(-157.72541 -170)"
                fill="#a0616a"
              />
              <path
                d="M936.8278,469.12849a13.47014,13.47014,0,0,0-3.16469-20.411l9.9463-46.82367-23.15832,9.08046-5.89475,43.07241a13.54316,13.54316,0,0,0,22.27146,15.08179Z"
                transform="translate(-157.72541 -170)"
                fill="#a0616a"
              />
              <polygon points="667.031 543.156 650.608 543.156 642.795 479.811 667.033 479.812 667.031 543.156" fill="#a0616a" />
              <path d="M828.944,729.07558l-52.95288-.002v-.66977A20.61031,20.61031,0,0,1,796.602,707.79331h.0013l32.34169.00131Z" transform="translate(-157.72541 -170)" fill="#2f2e41" />
              <polygon points="747.403 543.156 730.981 543.156 723.168 479.811 747.406 479.812 747.403 543.156" fill="#a0616a" />
              <path d="M909.31663,729.07558l-52.95288-.002v-.66977a20.61029,20.61029,0,0,1,20.61086-20.61054h.00131l32.34169.00131Z" transform="translate(-157.72541 -170)" fill="#2f2e41" />
              <path
                d="M826.467,680.08l-23.24744-.9301a6.04689,6.04689,0,0,1-5.784-6.20716l6.54958-214.83465.42776-.15436c40.74393-14.73891,74.44969-13.62437,103.04582,3.40249l.31984.191,3.92347,209.2397a6.02739,6.02739,0,0,1-6.027,6.14176H886.0721a6.04128,6.04128,0,0,1-5.91512-4.865L853.45309,536.22158a2.009,2.009,0,0,0-3.966.14652L832.69179,674.78331a6.06215,6.06215,0,0,1-5.98675,5.30062C826.62623,680.08393,826.54643,680.08262,826.467,680.08Z"
                transform="translate(-157.72541 -170)"
                fill="#2f2e41"
              />
              <circle cx="849.08311" cy="236.804" r="32.90059" transform="translate(-167.25852 266.29448) rotate(-28.66347)" fill="#a0616a" />
              <path
                d="M702.90807,269.53086A6.0355,6.0355,0,0,1,705.351,266.89l9.92209-5.69734a6.04761,6.04761,0,0,1,6.89787.62862l32.96658,27.92846,75.77217,21.24389a19.41873,19.41873,0,1,1-16.51422,35.15149l-48.40177-10.89628a62.11929,62.11929,0,0,1-36.5541-23.9993l-25.957-35.579a6.0346,6.0346,0,0,1-1.02618-4.80669A5.96744,5.96744,0,0,1,702.90807,269.53086Z"
                transform="translate(-157.72541 -170)"
                fill="#3f3d56"
              />
              <path
                d="M935.423,438.81388a6.03548,6.03548,0,0,1-3.59411.15526l-11.05723-2.94027a6.04762,6.04762,0,0,1-4.45566-5.30309l-3.7459-43.04373-38.84923-68.43583a19.41873,19.41873,0,1,1,36.4767-13.33406l26.69878,41.81668a62.11941,62.11941,0,0,1,9.05992,42.77951l-6.61835,43.54116a6.03461,6.03461,0,0,1-2.65563,4.13581A5.96772,5.96772,0,0,1,935.423,438.81388Z"
                transform="translate(-157.72541 -170)"
                fill="#3f3d56"
              />
              <path
                d="M813.0967,295.23124a56.02309,56.02309,0,0,1,44.92444-18.16365q.82512.051,1.64369.11512h.00066a55.905,55.905,0,0,1,40.40021,22.2987,56.74581,56.74581,0,0,1,10.07994,45.73812,177.30338,177.30338,0,0,0,4.68382,90.92287l8.82608,27.40572a6.026,6.026,0,0,1-5.41442,7.8659l-45.12263,2.426-11.547-19.94543v20.56623l-54.84217,2.94848c-.10923.00654-.21781.00916-.32573.00916a6.028,6.028,0,0,1-6.00637-6.512l6.19866-76.86551-7.775-52.2056A56.38041,56.38041,0,0,1,813.0967,295.23124Z"
                transform="translate(-157.72541 -170)"
                fill="#3f3d56"
              />
              <path
                d="M871.94892,268.21228c-3.04612,1.75271-15.08657,2.91479-15.9443-.4933l-.01838-.07488c-.59711-2.49707-.10127-5.10458.0701-7.66632s-.07938-5.37595-1.82412-7.25949c-3.25241-3.51113-9.03865-1.64985-13.74164-2.53763A11.6062,11.6062,0,0,1,831.462,237.786c.067-.53247.172-1.06554.28978-1.59828a8.93862,8.93862,0,0,0-9.27869-10.82526c-4.75284.27178-9.8831,1.7118-13.81548-1.80854-3.04091-2.72226-3.78282-9.80862-2.44673-13.66513,2.24539-6.48113,16.6287-9.87411,22.90869-11.73933a54.41263,54.41263,0,0,1,46.121,7.56782c3.96664,2.79595,7.67106,6.309,9.36172,10.858s.875,10.28809-2.93732,13.291a24.55655,24.55655,0,0,1,5.688,23.85251C885.4699,259.78622,876.48322,265.60329,871.94892,268.21228Z"
                transform="translate(-157.72541 -170)"
                fill="#2f2e41"
              />
              <path d="M1041.27459,730h-381a1,1,0,0,1,0-2h381a1,1,0,0,1,0,2Z" transform="translate(-157.72541 -170)" fill="#3f3d56" />
            </svg>

            <!-- Subtext -->
            <p class="text-gray-900 dark:text-white">Save podcasts, articles, videos, documents,... Wisery extracts information, summarizes it creates personalised reviews.</p>
          </div>
        </div>

        <div v-if="slide === 3">
          <h1 class="text-2xl font-semibold text-center text-gray-900 dark:text-white sm:mt-0 sm:pt-0 sm:text-4xl">Review & learn effortlessly</h1>
          <div class="my-8 space-y-8">
            <!-- Image -->
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-full h-full mx-auto sm:w-1/2"
              data-name="Layer 1"
              width="724.34614"
              height="519"
              viewBox="0 0 724.34614 519"
              xmlns:xlink="http://www.w3.org/1999/xlink"
            >
              <path d="M961.17307,709.5h-301a1,1,0,0,1,0-2h301a1,1,0,0,1,0,2Z" transform="translate(-237.82693 -190.5)" fill="#3f3d56" />
              <polygon points="535.418 507.548 523.159 507.548 517.326 460.26 535.421 460.261 535.418 507.548" fill="#ffb8b8" />
              <path d="M514.40147,504.04487h23.64387a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H499.51461a0,0,0,0,1,0,0v0A14.88686,14.88686,0,0,1,514.40147,504.04487Z" fill="#2f2e41" />
              <polygon points="624.374 493.661 613.222 498.754 588.269 458.165 604.727 450.648 624.374 493.661" fill="#ffb8b8" />
              <path
                d="M844.32492,687.2145H867.9688a0,0,0,0,1,0,0v14.88687a0,0,0,0,1,0,0H829.43807a0,0,0,0,1,0,0v0A14.88685,14.88685,0,0,1,844.32492,687.2145Z"
                transform="translate(-449.7177 224.89624) rotate(-24.54855)"
                fill="#2f2e41"
              />
              <path
                d="M826.498,538.605a10.05575,10.05575,0,0,0,.80112-15.39851l14.4116-32.69992-18.30864,3.10282-10.87858,30.57671A10.11027,10.11027,0,0,0,826.498,538.605Z"
                transform="translate(-237.82693 -190.5)"
                fill="#ffb8b8"
              />
              <path
                d="M772.464,685.5794H760.75208a4.51685,4.51685,0,0,1-4.48828-4.17383L743.87683,510.847a4.49978,4.49978,0,0,1,4.9253-4.80469l73.73486,7.19336a4.50131,4.50131,0,0,1,4.06225,4.39355l1.41944,75.23535a3.492,3.492,0,0,0,.23388,1.19336l27.78516,72.05274a4.49892,4.49892,0,0,1-2.64307,5.84082l-11.8684,4.37305a4.50111,4.50111,0,0,1-5.55738-2.16407L801.8363,607.79131a4.47493,4.47493,0,0,1-.40429-1.14258L795.6012,578.555a3.49993,3.49993,0,0,0-6.90406.3125l-11.7622,102.72364A4.499,4.499,0,0,1,772.464,685.5794Z"
                transform="translate(-237.82693 -190.5)"
                fill="#2f2e41"
              />
              <circle cx="540.46895" cy="162.42586" r="24.56103" fill="#ffb8b8" />
              <path
                d="M748.55066,511.83233c3.144,2.16894,38.56665,25.51172,78.94238,6.94531-.52319-4.50879-5.56152-49.7793-1.16089-83.15234,2.08765-15.834-4.21752-30.50293-17.29858-40.2461a49.73278,49.73278,0,0,0-50.02026-5.40136h-.00025q-.99426.44531-2.00244.92675Z"
                transform="translate(-237.82693 -190.5)"
                fill="#f50057"
              />
              <path
                d="M827.87634,518.40557a4.48617,4.48617,0,0,1-3.312-1.46l-5.37256-5.86133a4.52264,4.52264,0,0,1-.99829-4.31543l12.30493-41.64746L811.77625,425.805a8.33314,8.33314,0,0,1-.56958-5.54589,8.30927,8.30927,0,0,1,15.38745-1.96582l25.30932,41.06738a11.451,11.451,0,0,1,.6897,10.73047l-20.60986,45.665a4.48861,4.48861,0,0,1-3.38965,2.59179A4.56723,4.56723,0,0,1,827.87634,518.40557Z"
                transform="translate(-237.82693 -190.5)"
                fill="#f50057"
              />
              <path d="M766.72717,513.0794h-9.8125l17.12842-80.60352.98828.12891L771.22131,508.805A4.49651,4.49651,0,0,1,766.72717,513.0794Z" transform="translate(-237.82693 -190.5)" opacity="0.2" />
              <path
                d="M757.6479,533.119a10.0558,10.0558,0,0,0-2.41343-15.22929l7.30826-34.97954-17.26545,6.83651-4.29307,32.16906A10.11028,10.11028,0,0,0,757.6479,533.119Z"
                transform="translate(-237.82693 -190.5)"
                fill="#ffb8b8"
              />
              <path
                d="M756.65808,513.18a4.69328,4.69328,0,0,1-.50757-.02832l-10.4646-1.16308a4.515,4.515,0,0,1-3.99926-4.65821l4.32983-104.78222a13.52752,13.52752,0,0,1,26.73462-2.31543l2.78906,12.83008-.01367.09082L761.09754,509.346A4.48507,4.48507,0,0,1,756.65808,513.18Z"
                transform="translate(-237.82693 -190.5)"
                fill="#f50057"
              />
              <path
                d="M798.53211,374.5794c-2.5469.43668-4.64263-3.10848-4.95957-5.60213s.59189-4.88065.691-7.35813-1.0692-5.48813-3.64216-6.22268c-2.69746-.7701-5.198,1.39368-7.95937,1.13348-3.84789-.36258-5.77979-4.86573-6.24594-8.50854s-.83239-7.95675-4.16483-10.03412c-3.32214-2.07094-7.43185-.56414-11.24915-.49968-6.4517.10894-13.01929-4.81094-14.527-10.88235a3.65953,3.65953,0,0,0,4.1745-1.67179,3.70377,3.70377,0,0,0-1.1144-4.37824l7.31314,3.58106c-.99948-2.03411.51-4.35112,2.58767-5.12143s4.49481-.42436,6.78761-.06815c11.45045,1.77895,24.71315.90216,32.30847,9.6327,5.2609,6.04722,9.5914,17.55438,9,25S798.53211,374.5794,798.53211,374.5794Z"
                transform="translate(-237.82693 -190.5)"
                fill="#2f2e41"
              />
              <path
                d="M519.82656,651.5h-263a7.00787,7.00787,0,0,1-7-7L237.82693,197.52686A7.01308,7.01308,0,0,1,244.82656,190.5h263a7.00786,7.00786,0,0,1,7,7l2.17408,80.97314-1.999.05372-2.1748-81A5.01188,5.01188,0,0,0,507.82656,192.5h-263a5.00581,5.00581,0,0,0-5,5L251.8262,644.47314A5.01213,5.01213,0,0,0,256.82656,649.5h263a5.00573,5.00573,0,0,0,5-5l-2.3352-86.97314,1.99927-.05372,2.33569,87A7.01326,7.01326,0,0,1,519.82656,651.5Z"
                transform="translate(-237.82693 -190.5)"
                fill="#ccc"
              />
              <rect x="518.7377" y="398.49308" width="2.00023" height="38.39957" transform="translate(-248.84923 -176.40152) rotate(-1.53781)" fill="#ccc" />
              <path
                d="M496.22647,612.10938H278.36709a5.977,5.977,0,0,1-5.97021-5.97022L262.45694,235.8877a5.98216,5.98216,0,0,1,5.96972-5.99707H486.286a5.977,5.977,0,0,1,5.97021,5.97021l1.8003,42.59717-1.99805.084-1.80127-42.63916a3.98544,3.98544,0,0,0-3.97119-4.0122H268.42666a3.97481,3.97481,0,0,0-3.97009,3.97021l9.93994,370.25146a3.98118,3.98118,0,0,0,3.97058,3.99708H496.22647a3.97483,3.97483,0,0,0,3.97021-3.97022l-1.28735-48.61279,1.99927-.05274,1.28759,48.63916A5.98191,5.98191,0,0,1,496.22647,612.10938Z"
                transform="translate(-237.82693 -190.5)"
                fill="#ccc"
              />
              <rect x="495.22905" y="399.49334" width="2.00021" height="38.01331" transform="translate(-248.72699 -177.22289) rotate(-1.51626)" fill="#ccc" />
              <path
                d="M554.19668,399.5h-255a7.00778,7.00778,0,0,1-6.99975-6.94238L288.19668,284.5a7.00787,7.00787,0,0,1,7-7h255a7.00763,7.00763,0,0,1,6.99976,6.94238L561.19668,392.5A7.00786,7.00786,0,0,1,554.19668,399.5ZM290.19693,284.44727,294.19668,392.5a5.0058,5.0058,0,0,0,5,5h255a5.006,5.006,0,0,0,4.99976-4.94727L555.19668,284.5a5.00573,5.00573,0,0,0-5-5h-255A5.00587,5.00587,0,0,0,290.19693,284.44727Z"
                transform="translate(-237.82693 -190.5)"
                fill="#3f3d56"
              />
              <path
                d="M602.19668,558.5h-255a7.00778,7.00778,0,0,1-6.99975-6.94238L336.19668,443.5a7.00787,7.00787,0,0,1,7-7h255a7.00763,7.00763,0,0,1,6.99976,6.94238L609.19668,551.5A7.00786,7.00786,0,0,1,602.19668,558.5ZM338.19693,443.44727,342.19668,551.5a5.0058,5.0058,0,0,0,5,5h255a5.006,5.006,0,0,0,4.99976-4.94727L603.19668,443.5a5.00573,5.00573,0,0,0-5-5h-255A5.00587,5.00587,0,0,0,338.19693,443.44727Z"
                transform="translate(-237.82693 -190.5)"
                fill="#3f3d56"
              />
              <path d="M407.69668,460a6.5,6.5,0,0,0,0,13h130a6.5,6.5,0,0,0,0-13Z" transform="translate(-237.82693 -190.5)" fill="#f50057" />
              <path d="M407.69668,491a6.5,6.5,0,0,0,0,13h130a6.5,6.5,0,0,0,0-13Z" transform="translate(-237.82693 -190.5)" fill="#f50057" />
              <path d="M407.69668,522a6.5,6.5,0,0,0,0,13h130a6.5,6.5,0,0,0,0-13Z" transform="translate(-237.82693 -190.5)" fill="#f50057" />
              <path d="M359.69668,301a6.5,6.5,0,0,0,0,13h130a6.5,6.5,0,0,0,0-13Z" transform="translate(-237.82693 -190.5)" fill="#f50057" />
              <path d="M359.69668,332a6.5,6.5,0,0,0,0,13h130a6.5,6.5,0,0,0,0-13Z" transform="translate(-237.82693 -190.5)" fill="#f50057" />
              <path d="M359.69668,363a6.5,6.5,0,0,0,0,13h130a6.5,6.5,0,0,0,0-13Z" transform="translate(-237.82693 -190.5)" fill="#f50057" />
              <circle cx="140.36975" cy="20" r="10" fill="#e6e6e6" />
            </svg>

            <!-- Subtext -->
            <p class="text-gray-900 dark:text-white">Reviews are once a day, take 2-3 minutes and include powerful learning techniques that compound your knowledge.</p>
          </div>
        </div>

        <div v-if="slide === 4">
          <h1 class="text-2xl font-semibold text-center text-gray-900 dark:text-white sm:mt-0 sm:pt-0 sm:text-4xl">Get started</h1>
          <h3 class="text-lg text-gray-700 dark:text-gray-200">Save your first content</h3>
          <div class="mt-10 divide-y divide-indigo-100 dark:divide-indigo-900">
            <!-- Mobile -->
            <div class="px-4 pb-6 sm:pb-8 sm:flex sm:items-center sm:justify-between sm:space-x-5">
              <div class="mb-5 space-y-1 text-left">
                <p class="font-semibold dark:text-white">Saving content on mobile</p>
                <p class="text-sm text-gray-500 dark:text-gray-200">Simply share any link to our WhatsApp or SMS channel</p>
              </div>
              <div class="block space-y-2">
                <div>
                  <a
                    :href="`https://wa.me/+18317039919?text=/start%20${uid}`"
                    class="inline-flex items-center justify-center w-full px-3 py-2 text-base font-medium text-gray-800 border border-transparent rounded-md shadow bg-slate-100 hover:bg-slate-200 dark:bg-gray-700 dark:text-white hover:dark:bg-gray-600 sm:w-auto"
                  >
                    <div class="relative flex items-center">
                      <v-icon name="bi-whatsapp" class="w-6 h-6 mr-1" />
                      <span>Connect WhatsApp</span>
                    </div>
                  </a>
                </div>
                <div class="text-gray-400">or</div>
                <div>
                  <a
                    :href="`sms:+18317039919&body=/start%20${uid}`"
                    class="inline-flex items-center justify-center w-full px-3 py-2 text-base font-medium text-gray-800 border border-transparent rounded-md shadow bg-slate-100 hover:bg-slate-200 dark:bg-gray-700 dark:text-white hover:dark:bg-gray-600 sm:w-auto"
                  >
                    <div class="flex items-center text-sm">
                      <v-icon name="fa-sms" class="w-6 h-6 mr-1" />
                      <span>Connect SMS</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <!-- Extension -->
            <div class="px-4 py-6 sm:py-8 sm:flex sm:items-center sm:justify-between sm:space-x-5">
              <div class="mb-5 space-y-1 text-left sm:mb-0">
                <p class="font-semibold dark:text-white">Saving content on desktop</p>
                <p class="text-sm text-gray-500 dark:text-gray-200">Use keyboard shortcuts to save as you browse</p>
              </div>
              <div class="block text-left">
                <div>
                  <a
                    :href="chromeExtension.url"
                    class="inline-flex items-center justify-center w-full px-3 py-2 text-base font-medium text-gray-800 border border-transparent rounded-md shadow bg-slate-100 hover:bg-slate-200 dark:bg-gray-700 dark:text-white hover:dark:bg-gray-600 sm:w-auto"
                  >
                    <div class="flex items-center text-sm">
                      <v-icon name="si-googlechrome" class="w-6 h-6 mr-1" />
                      <span>Install Browser Extension</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>

            <!-- File upload -->
            <div class="px-4 pt-6 sm:pt-8 sm:flex sm:items-center sm:justify-between sm:space-x-5">
              <div class="mb-5 space-y-1 text-left sm:mb-0">
                <p class="font-semibold dark:text-white">Upload text or documents</p>
                <p class="text-sm text-gray-500 dark:text-gray-200">Upload any text or document such as PDF, .txt. docx,...</p>
              </div>
              <div class="block text-left">
                <div>
                  <router-link
                    to="/upload"
                    class="inline-flex items-center justify-center w-full px-3 py-2 text-base font-medium text-gray-800 border border-transparent rounded-md shadow bg-slate-100 hover:bg-slate-200 dark:bg-gray-700 dark:text-white hover:dark:bg-gray-600 sm:w-auto"
                  >
                    <div class="flex items-center text-sm">
                      <v-icon name="hi-document-add" class="w-6 h-6 mr-1" />
                      <span>Upload Document</span>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- nav -->
        <div class="flex items-center justify-between px-4 mt-10 space-x-3 sm:space-x-6 sm:px-6 sm:pt-6" :class="{ 'justify-end': slide === 1, 'justify-between': slide != 1 }">
          <div class="w-4 sm:w-6"><wbr /></div>
          <!-- Progress bars -->
          <div class="flex items-center px-4 py-4 mx-auto space-x-3 sm:space-x-5 sm:px-0 sm:pb-3">
            <template v-for="index in 4" :key="index">
              <div
                class="h-0.5 w-3 rounded"
                :class="{
                  'bg-slate-400 dark:bg-white ': slide >= index,
                  'bg-slate-300/70 dark:bg-gray-600': slide < index,
                }"
              ></div>
            </template>
          </div>
          <button
            @click="nextSlide"
            class="flex justify-end py-2 space-x-1 text-sm font-semibold rounded-md sm:text-md text-slate-400 hover:text-slate-600 focus:outline-none dark:text-slate-200 dark:hover:text-slate-50"
            :class="{ invisible: slide === 4 }"
          >
            <!-- <span>Next</span> -->
            <ArrowRightIcon class="w-4 sm:w-6" />
          </button>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide } from "vue3-carousel";
import { ref, watchEffect } from "vue";
import utilFunctions from "../composables/util";
import firebaseUser from "../composables/userAuth";
import UserProfilePhoto from "./nav/UserProfilePhoto.vue";
import { MenuAlt4Icon, PlusIcon, ArrowRightIcon } from "@heroicons/vue/outline";
import IconBlackSvg from "../components/logos/IconBlackSvg.vue";
import chromeExtension from "../composables/chromeExtension";

export default {
  components: {
    Carousel,
    Slide,
    UserProfilePhoto,
    MenuAlt4Icon,
    PlusIcon,
    IconBlackSvg,
    ArrowRightIcon,
  },
  setup() {
    const { getUser, userInitials } = utilFunctions();
    const { user } = firebaseUser();
    const userData = ref(null);
    const onboardingCarousel = ref(null);
    const nextSlide = () => onboardingCarousel.value.next();

    const uid = ref(null);

    watchEffect(async () => {
      if (user.value) {
        userData.value = await getUser(user.value.uid);
        uid.value = user.value.uid;
      }
    });
    return {
      onboardingCarousel,
      nextSlide,
      userInitials,
      userData,
      uid,
      chromeExtension,
    };
  },
};
</script>

<style scoped>
.carousel__slide {
  height: fit-content;
}
</style>
